export default __webpack_public_path__ + "static/media/gilroy-semibold-webfont.b2edfbfa.woff";